import DeleteIcon from '@mui/icons-material/Delete';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import { GridActionsCellItem } from '@mui/x-data-grid';

import TableActionButtons from '../../components/shared/TableActionButtons/TableActionButtons';

const useVersionControlTableColumns = (
  deleteItem,
  editItem,
  downloadItem,
  apiRef,
  columnPermissions = {},
) => {
  const { canEdit = false, canDelete = false } = columnPermissions;

  const columnsData = [
    {
      field: 'version',
      headerName: 'ورژن',
      flex: 1,
      minWidth: 250,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.version;
      },
    },
    {
      field: 'dateTime',
      headerName: 'تاریخ',
      flex: 1,
      minWidth: 250,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.dateTime;
      },
    },
    {
      field: 'isForced',
      headerName: 'بروزرسانی ضروری',
      flex: 1,
      minWidth: 250,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.isForced ? 'بله' : 'خیر';
      },
    },

    {
      field: 'actions',
      headerName: 'عملیات',
      type: 'actions',
      flex: 0.5,
      align: 'right',
      minWidth: 240,

      getActions: params => {
        return [
          canEdit ? (
            <TableActionButtons
              key={10}
              buttons={[
                {
                  label: 'ویرایش',
                  Icon: ModeEditOutlineIcon,
                  onClick: editItem(params.row),
                  color: 'info',
                },
              ]}
            />
          ) : null,
          canDelete ? (
            <GridActionsCellItem
              key={2}
              icon={<DeleteIcon />}
              label="حذف"
              onClick={deleteItem(params.row)}
              showInMenu
            />
          ) : null,
          <GridActionsCellItem
            key={3}
            icon={<FileDownloadIcon />}
            label="دانلود فایل"
            onClick={downloadItem(params.row)}
            showInMenu
          />,
        ].filter(Boolean);
      },
    },
  ];

  return [columnsData];
};

export default useVersionControlTableColumns;
